export default "__VITE_ASSET__CrPYG0dR__"